export const MyEqual = `<svg width="22" height="11" viewBox="0 0 22 11" fill="none" class="feather" style="stroke: auto" xmlns="http://www.w3.org/2000/svg">
<path d="M1.5 1H20.1667" stroke="auto" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1.5 10H20.1667" stroke="auto" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;